const SHOP = {
    VIEW: "shop_view",
    CREATE: "shop_create",
    UPDATE: "shop_update",
    DELETE: "shop_delete",
    STATISTIC: "",
}

const SHOP_ENTRY = {
    VIEW: 'entry_shop_view',
    CREATE: 'entry_shop_create',
    UPDATE: 'entry_shop_update',
    DELETE: 'entry_shop_delete',
}
const SHOP_TRANSFER = {
    VIEW: 'transfer_shop_view',
    CREATE: 'transfer_shop_create',
    UPDATE: 'transfer_shop_update',
    DELETE: 'transfer_shop_delete',
    VALIDATE: 'transfer_shop_validate',
}
const SHOP_USER = {
    VIEW: 'shop_user_view',
    CREATE: 'shop_user_create',
    UPDATE: 'shop_user_update',
    DELETE: 'shop_user_delete',
}
const SHOP_CASH_BOX = {
    VIEW: 'shop_cash_box_view',
    CREATE: 'shop_cash_box_create',
    UPDATE: 'shop_cash_box_update',
    DELETE: 'shop_cash_box_delete',
}
const SHOP_SALE = {
    VIEW: 'shop_sale_view',
    CREATE: 'shop_sale_create',
    UPDATE: 'shop_sale_update',
    DELETE: 'shop_sale_delete',
    STATS: 'shop_sale_stats',
    OPEN_SESSION: 'shop_sale_open_session',
    CLOSE_SESSION: 'shop_sale_close_session',
}
const SHOP_STORE = {
    VIEW: 'shop_store_view',
    CREATE: 'shop_store_create',
    UPDATE: 'shop_store_update',
    DELETE: 'shop_store_delete',
}
const SHOP_PRODUCT = {
    VIEW: 'shop_product_view',
    CREATE: 'shop_product_create',
    UPDATE: 'shop_product_update',
    DELETE: 'shop_product_delete',
}

const STORE = {
    VIEW: 'magasin_view',
    CREATE: 'magasin_create',
    UPDATE: 'magasin_update',
    DELETE: 'magasin_delete',
}

const STORE_USER = {
    VIEW: 'user_magasin_view',
    CREATE: 'user_magasin_create',
    UPDATE: 'user_magasin_update',
    DELETE: 'user_magasin_delete',
}

const STORE_PRODUCT = {
    VIEW: 'product_magasin_view',
    CREATE: 'product_magasin_create',
    UPDATE: 'product_magasin_update',
    DELETE: 'product_magasin_delete',
}
export default {
    SHOP,
    SHOP_ENTRY,
    SHOP_TRANSFER,
    SHOP_USER,
    SHOP_CASH_BOX,
    SHOP_SALE,
    SHOP_STORE,
    SHOP_PRODUCT,
    STORE,
    STORE_USER,
    STORE_PRODUCT
}
